module.exports = __webpack_public_path__ + "static/media/buildingsoutline.8bcba133.svg";